import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google';
import Script from 'next/script';

// Environment variables for 3rd-party scripts
const googleAnalyticsId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID;
const googleTagManagerId = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;
const monsidoToken = process.env.NEXT_PUBLIC_MONSIDO_TOKEN;
const munchkinId = process.env.NEXT_PUBLIC_MUNCHKIN_ID;

// Loaders
const handleReadyMonsido = (): void => {
  if (monsidoToken) {
    window._monsido = window._monsido ?? {
      token: monsidoToken,
    };
  }
};
const handleReadyMunchkin = (): void => {
  if (munchkinId) {
    window.Munchkin?.init(munchkinId);
  }
};

/**
 * This component is used to keep all the 3rd-party scripts in one place
 */
const AppScripts = () => (
  <>
    {/* any scripts that need to be loaded before the page loads should not be added here */}
    {/* add those scripts in src/pages/_document.tsx */}
    {/* see: https://www.notion.so/triumphpay/Adding-third-party-scripts-1de6b1d1b40080f09b10dfe04112076c?pvs=4 */}
    {googleAnalyticsId && (
      <GoogleAnalytics gaId={googleAnalyticsId} />
    )}

    {googleTagManagerId && (
      <GoogleTagManager gtmId={googleTagManagerId} />
    )}

    {monsidoToken && (
      <Script
        async
        id="monsido-script"
        onReady={handleReadyMonsido}
        src="https://app-script.monsido.com/v2/monsido-script.js"
      />
    )}

    {munchkinId && (
      <Script
        async
        id="munchkin-script"
        onReady={handleReadyMunchkin}
        src="//munchkin.marketo.net/munchkin.js"
      />
    )}
  </>
);

export default AppScripts;
